// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Squad In Touch — Color tokens
   Brand mark colours: blue #007dbe / navy #164170, green #66952e,
   orange #f26522, maroon #9e2718, wordmark graphite #333132.
   UI palette: a single cool slate neutral ramp + a calm
   "Squad blue" primary, with restrained semantic accents.
   ============================================================ */

:root {
  /* ---- Brand mark (illustrative / decorative use only) ---- */
  --brand-blue: #007dbe;
  --brand-navy: #164170;
  --brand-green: #66952e;
  --brand-green-deep: #235413;
  --brand-orange: #f26522;
  --brand-maroon: #9e2718;
  --brand-graphite: #333132;

  /* ---- Primary: Squad blue (interactive) ---- */
  --blue-50:  #eef6fc;
  --blue-100: #d4e8f6;
  --blue-200: #a9d1ed;
  --blue-300: #6fb1df;
  --blue-400: #3b93cf;
  --blue-500: #227ebd;   /* primary */
  --blue-600: #1a6da3;   /* hover */
  --blue-700: #155d8c;   /* active */
  --blue-800: #124d74;
  --blue-900: #0f3d5c;

  /* ---- Neutral: cool slate ramp ---- */
  --slate-0:   #ffffff;
  --slate-25:  #fafbfc;
  --slate-50:  #f8fafc;
  --slate-100: #f1f5f9;
  --slate-150: #eef2f7;
  --slate-200: #e2e8f0;
  --slate-300: #cbd5e1;
  --slate-400: #94a3b8;
  --slate-500: #64748b;
  --slate-600: #475569;
  --slate-700: #334155;
  --slate-800: #1e293b;
  --slate-900: #0f172a;

  /* ---- Semantic accents ---- */
  --green-50:  #ecf8f0;
  --green-100: #d3f0dd;
  --green-500: #2f9e5a;   /* success */
  --green-600: #268049;
  --green-700: #1f6b3d;

  --amber-50:  #fff6e6;
  --amber-100: #ffe9c2;
  --amber-500: #f08c1a;   /* warning */
  --amber-600: #d4760c;
  --amber-700: #a85c07;

  --red-50:   #fdecee;
  --red-100:  #f9d4d9;
  --red-500:  #da4453;    /* danger — legacy grapefruit */
  --red-600:  #c4313f;
  --red-700:  #a52836;

  --aqua-50:  #e9f6fb;
  --aqua-100: #cdeaf5;
  --aqua-500: #3bafda;    /* info — legacy aqua */
  --aqua-600: #2496c1;

  --orange-notify: #f97316; /* notification dot / counter badge */

  /* ============================================================
     Semantic aliases — reference these in components, not the
     raw ramps above.
     ============================================================ */

  /* surfaces */
  --surface-page:    var(--slate-50);
  --surface-card:    var(--slate-0);
  --surface-sunken:  var(--slate-100);
  --surface-raised:  var(--slate-0);
  --surface-hover:   var(--slate-100);
  --surface-active:  var(--slate-150);
  --surface-inverse: var(--slate-900);
  --surface-brand-subtle: var(--blue-50);

  /* text */
  --text-strong:     var(--slate-900);
  --text-body:       var(--slate-700);
  --text-muted:      var(--slate-500);
  --text-subtle:     var(--slate-400);
  --text-on-brand:   #ffffff;
  --text-on-dark:    var(--slate-100);
  --text-link:       var(--blue-600);

  /* borders */
  --border-subtle:   var(--slate-200);
  --border-default:  var(--slate-300);
  --border-strong:   var(--slate-400);
  --border-brand:    var(--blue-500);
  --hairline:        rgba(15, 23, 42, 0.08);

  /* interactive — primary */
  --action-primary:        var(--blue-500);
  --action-primary-hover:  var(--blue-600);
  --action-primary-active: var(--blue-700);

  /* focus */
  --focus-ring:      rgba(34, 126, 189, 0.35);

  /* status backgrounds + foregrounds (badges, banners) */
  --status-success-bg: var(--green-50);
  --status-success-fg: var(--green-700);
  --status-warning-bg: var(--amber-50);
  --status-warning-fg: var(--amber-700);
  --status-danger-bg:  var(--red-50);
  --status-danger-fg:  var(--red-700);
  --status-info-bg:    var(--aqua-50);
  --status-info-fg:    var(--aqua-600);
  --status-neutral-bg: var(--slate-100);
  --status-neutral-fg: var(--slate-600);
}
`, "",{"version":3,"sources":["webpack://./src/styles/squad-theme/tokens/colors.css"],"names":[],"mappings":"AAAA;;;;;;iEAMiE;;AAEjE;EACE,8DAA8D;EAC9D,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;;EAEzB,gDAAgD;EAChD,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,IAAI,YAAY;EACnC,mBAAmB,IAAI,UAAU;EACjC,mBAAmB,IAAI,WAAW;EAClC,mBAAmB;EACnB,mBAAmB;;EAEnB,uCAAuC;EACvC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,+BAA+B;EAC/B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB,IAAI,YAAY;EACpC,oBAAoB;EACpB,oBAAoB;;EAEpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB,IAAI,YAAY;EACpC,oBAAoB;EACpB,oBAAoB;;EAEpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,KAAK,+BAA+B;EACvD,mBAAmB;EACnB,mBAAmB;;EAEnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,KAAK,uBAAuB;EAC/C,mBAAmB;;EAEnB,wBAAwB,EAAE,qCAAqC;;EAE/D;;;mEAGiE;;EAEjE,aAAa;EACb,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,sCAAsC;;EAEtC,SAAS;EACT,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;;EAElC,YAAY;EACZ,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;;EAEzC,0BAA0B;EAC1B,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;;EAExC,UAAU;EACV,2CAA2C;;EAE3C,uDAAuD;EACvD,oCAAoC;EACpC,qCAAqC;EACrC,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;AACvC","sourcesContent":["/* ============================================================\n   Squad In Touch — Color tokens\n   Brand mark colours: blue #007dbe / navy #164170, green #66952e,\n   orange #f26522, maroon #9e2718, wordmark graphite #333132.\n   UI palette: a single cool slate neutral ramp + a calm\n   \"Squad blue\" primary, with restrained semantic accents.\n   ============================================================ */\n\n:root {\n  /* ---- Brand mark (illustrative / decorative use only) ---- */\n  --brand-blue: #007dbe;\n  --brand-navy: #164170;\n  --brand-green: #66952e;\n  --brand-green-deep: #235413;\n  --brand-orange: #f26522;\n  --brand-maroon: #9e2718;\n  --brand-graphite: #333132;\n\n  /* ---- Primary: Squad blue (interactive) ---- */\n  --blue-50:  #eef6fc;\n  --blue-100: #d4e8f6;\n  --blue-200: #a9d1ed;\n  --blue-300: #6fb1df;\n  --blue-400: #3b93cf;\n  --blue-500: #227ebd;   /* primary */\n  --blue-600: #1a6da3;   /* hover */\n  --blue-700: #155d8c;   /* active */\n  --blue-800: #124d74;\n  --blue-900: #0f3d5c;\n\n  /* ---- Neutral: cool slate ramp ---- */\n  --slate-0:   #ffffff;\n  --slate-25:  #fafbfc;\n  --slate-50:  #f8fafc;\n  --slate-100: #f1f5f9;\n  --slate-150: #eef2f7;\n  --slate-200: #e2e8f0;\n  --slate-300: #cbd5e1;\n  --slate-400: #94a3b8;\n  --slate-500: #64748b;\n  --slate-600: #475569;\n  --slate-700: #334155;\n  --slate-800: #1e293b;\n  --slate-900: #0f172a;\n\n  /* ---- Semantic accents ---- */\n  --green-50:  #ecf8f0;\n  --green-100: #d3f0dd;\n  --green-500: #2f9e5a;   /* success */\n  --green-600: #268049;\n  --green-700: #1f6b3d;\n\n  --amber-50:  #fff6e6;\n  --amber-100: #ffe9c2;\n  --amber-500: #f08c1a;   /* warning */\n  --amber-600: #d4760c;\n  --amber-700: #a85c07;\n\n  --red-50:   #fdecee;\n  --red-100:  #f9d4d9;\n  --red-500:  #da4453;    /* danger — legacy grapefruit */\n  --red-600:  #c4313f;\n  --red-700:  #a52836;\n\n  --aqua-50:  #e9f6fb;\n  --aqua-100: #cdeaf5;\n  --aqua-500: #3bafda;    /* info — legacy aqua */\n  --aqua-600: #2496c1;\n\n  --orange-notify: #f97316; /* notification dot / counter badge */\n\n  /* ============================================================\n     Semantic aliases — reference these in components, not the\n     raw ramps above.\n     ============================================================ */\n\n  /* surfaces */\n  --surface-page:    var(--slate-50);\n  --surface-card:    var(--slate-0);\n  --surface-sunken:  var(--slate-100);\n  --surface-raised:  var(--slate-0);\n  --surface-hover:   var(--slate-100);\n  --surface-active:  var(--slate-150);\n  --surface-inverse: var(--slate-900);\n  --surface-brand-subtle: var(--blue-50);\n\n  /* text */\n  --text-strong:     var(--slate-900);\n  --text-body:       var(--slate-700);\n  --text-muted:      var(--slate-500);\n  --text-subtle:     var(--slate-400);\n  --text-on-brand:   #ffffff;\n  --text-on-dark:    var(--slate-100);\n  --text-link:       var(--blue-600);\n\n  /* borders */\n  --border-subtle:   var(--slate-200);\n  --border-default:  var(--slate-300);\n  --border-strong:   var(--slate-400);\n  --border-brand:    var(--blue-500);\n  --hairline:        rgba(15, 23, 42, 0.08);\n\n  /* interactive — primary */\n  --action-primary:        var(--blue-500);\n  --action-primary-hover:  var(--blue-600);\n  --action-primary-active: var(--blue-700);\n\n  /* focus */\n  --focus-ring:      rgba(34, 126, 189, 0.35);\n\n  /* status backgrounds + foregrounds (badges, banners) */\n  --status-success-bg: var(--green-50);\n  --status-success-fg: var(--green-700);\n  --status-warning-bg: var(--amber-50);\n  --status-warning-fg: var(--amber-700);\n  --status-danger-bg:  var(--red-50);\n  --status-danger-fg:  var(--red-700);\n  --status-info-bg:    var(--aqua-50);\n  --status-info-fg:    var(--aqua-600);\n  --status-neutral-bg: var(--slate-100);\n  --status-neutral-fg: var(--slate-600);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
